const commonity = {
  // 社区首页
  getCommunityList: `/forumApi/v1/Community/getCommunityList`,
  // 获取社区子模块和分类
  pcCommunityHome: `/forumApi/v1/Community/pcCommunityHome`,
  // 获取栏目帖子列表、置顶帖子
  getPostByCategory: `/forumApi/v2/Post/getPostByCategory`,
  // 获取社区页面栏目
  getPostNavBar: `/forumApi/v1/Category/getPostNavBar`,
  // 删除帖子
  deletePost: `/forumApi/v1/Post/deletePost`,
  // 点赞/取消点赞
  doUpvote: `/forumApi/v1/Upvote/doUpvote`,
  // 分享后回调
  doShare: `/forumApi/v1/Share/doShare`,
  // 获取发帖选择栏目
  getPostCategory: `/forumApi/v2/Category/getPostCategory`,
  // 图片上传
  uploadImg: `/forumApi/v1/Post/uploadImg`,
  // 视频上传
  uploadVideo: `/forumApi/v1/Post/uploadVideo`,
  // 发布帖子
  publishPost: `/forumApi/v2/Post/publishPost`,
  // 编辑帖子 ----- 刘阳
  modifyPost: `/forumApi/v2/Post/modifyPost`,
  // 帖子详情
  postDetail: `/forumApi/v1/Post/postDetail`,
  // 收藏/取消收藏
  doCollect: `/forumApi/v1/Collect/doCollect`,
  // 关注列表
  follows: `/forumApi/v1/User/follows`,
  // 关注/取消关注
  doFollow: `/forumApi/v1/User/doFollow`,
  // 粉丝列表
  fans: `/forumApi/v1/User/fans`,
  // 我的/他人帖子列表
  getUserPost: `/forumApi/v1/Post/getUserPost`,
  // 回复帖子列表
  getReplyPosts: `/forumApi/v1/Post/getReplyPosts`,
  // 用户详情
  detail: `/forumApi/v1/User/detail`,
  // 我的/他人收藏列表
  collectionList: `/forumApi/v1/Collect/collectionList`,
  // 获取一级评论
  getComment: `/forumApi/v1/Comment/getComment`,
  // 获取二级评论
  getChildComment: `/forumApi/v1/Comment/getChildComment`,
  // 发表评论
  doComment: `/forumApi/v1/Comment/doComment`,
  // 发表评论（新） ----- 刘阳
  doCommentNew: `/forumApi/v1/Comment/doCommentNew`,
  // 用户信用分 ----- 刘阳
  getCredit: `/forumApi/v1/User/getCredit`,
  // 删除评论 ----- 刘阳
  deleteComment: `/forumApi/v1/Comment/deleteComment`,
  // 帖子热评 ----- 刘阳
  getHotComment: `/forumApi/v1/Comment/getHotComment`,
  // Banner列表 ----- 刘阳
  getBannerList: `/forumApi/v1/Banner/getList`,
  // 创作者激励页面 ----- 刘阳
  creatorRewardPage: `/forumApi/v1/Banner/creatorRewardPage`,
  // 创作者榜单 ----- 刘阳
  creatorRankPage: `/forumApi/v1/Banner/creatorRankPage`,
  // 搜索推荐帖子列表 ----- 刘阳
  recommend: `/forumApi/v1/PostSearch/recommend`,
  // 搜索推荐帖子列表 ----- 刘阳
  searchPosts: `/userApi/v1/Essearch/searchPosts`,
  // 搜索关键字联想 ----- 刘阳
  keywordExpansion: `/userApi/v1/Essearch/keywordExpansion`,
  // 编辑器专用搜索推荐帖子列表 ----- 刘阳
  postSearchPosts: `/forumApi/v1/PostSearch/searchPosts`,
  // 保存草稿 ----- 刘阳
  saveDraft: `/forumApi/v1/Draft/saveDraft`,
  // 草稿箱列表 ----- 刘阳
  draftList: `/forumApi/v1/Draft/draftList`,
  // 删除草稿 ----- 刘阳
  deleteDraft: `/forumApi/v1/Draft/deleteDraft`,
  // 玩家攻略列表 ----- 刘阳
  playerStrategyList: '/forumApi/v3/Post/playerStrategyList',
  // 全部游戏-PC ----- 刘阳
  pcGameList: '/forumApi/v1/Game/pcGameList',
  // 社区模块推荐列表 ----- 刘阳
  postRecommend: `/userApi/v1/Essearch/postRecommend`,
  // 获取评论用户游戏数据 ----- 刘阳
  getUserGameData: '/forumApi/v1/Game/getUserGameData'
};

export default commonity;
